import { cn } from '@/lib/utils';
import { getInitials } from '@/lib/utils/string';

interface AvatarProps {
  avatarUrl?: string | null;
  name?: string | null;
  email?: string | null;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizeClasses = {
  sm: 'size-10 text-sm',
  md: 'size-14 text-base',
  lg: 'size-20 text-xl',
  xl: 'size-24 text-2xl',
};

export function Avatar({
  avatarUrl,
  name,
  email,
  size = 'md',
  className,
}: AvatarProps) {
  const initials = getInitials(name, email);

  if (avatarUrl) {
    return (
      <img
        src={avatarUrl}
        alt={name || email || 'User'}
        className={cn(
          'rounded-full object-cover',
          sizeClasses[size],
          className,
        )}
      />
    );
  }

  return (
    <div
      className={cn(
        'bg-primary border-primary-border flex items-center justify-center rounded-full border font-semibold text-white',
        sizeClasses[size],
        className,
      )}>
      {initials}
    </div>
  );
}
